var messages = {
  alert: {
    cancelButtonText: "إلغاء",
    confirmButtonText: "تأكيد",
    networkError: "خطأ في الشبكة",
  },
  meta: {
    homePage: "الصفحة الرئيسية",
    userPage: "أنا",
    userManagement: "إدارة المستخدم",
    systemLanguage: "لغة النظام",
    autoLanguage: "اختيار اللغة التلقائي",
    search: "بحث",
    noMore: "لا يوجد المزيد",
    uploadSuccess: "نجاح التحميل",
    uploadFail: "فشل التحميل",
    loading: "التحميل",
    privacy1: "اتفاقية المستخدم",
    privacy2: "سياسة الخصوصية",
    privacy3: "سياسة الشحن",
    confirm: "أكد",
    cancel: "الإلغاء",
    copySuccess: "نجاح النسخ",
    input: "يرجى الإدخال",
    select: "يرجى الاختيار",
    searchType: "ظروف البحث",
    allFilter: "جميع الفلاتر",
    kefuList: "خدمة العملاء",
    reset: "إعادة تعيين",
    yes: "نعم",
    no: "لا"
  },
  home: {
    title: "vTrack محطة لوجستيات",
    freightInquiry: " عرض سعر",
    freightInquiryDetail: "تفاصيل الاقتباس",
    orderDetail: "تذكرة الشحن",
    orderException: "التعامل مع استثناء الأمر",
    cargoInquiry: "تتبع",
    goodsForecast: "توقُّعات الشراء",
    accountList: "بيان ",
    shippingAddress: "العنوان",
    freightPriceCalculator: "آلة حاسبة",
    nickname: "الإسم المستعار",
    qrCode: " التقاط رمز الاستجابة السريعة (QR) ",
    customerNumber: "الهوية",
    payCompletion: "الدفع",
    backHome: "العودة إلى الوطن",
    pointsList: "تفاصيل النقاط",
    shipNow: "السَّفينة الآن",
    details: "تفاصيل المنتج"
  },
  auth: {
    login: "تسجيل الدخول",
    logInSuccess: "تم تسيل الدخول بنجاح",
    inputPhoneNumber: "يرجى إدخال رقم الهاتف",
    inputEmail: "الرجاء إدخال البريد الإلكتروني",
    inputCorrentPhoneNumber: "الرجاء إدخال رقم الهاتف الصحيح",
    inputCorrentEmail: "الرجاء إدخال البريد الإلكتروني الصحيح",
    phoneNumber: "رقم الهاتف",
    email: "البريد الإلكتروني",
    inputVcode: "يرجى إدخال رمز التحقق",
    inputUsername: "رقم الهاتف/البريد الإلكتروني/هوية العميل",
    inputPassword: "يرجى إدخال كلمة السر",
    inputCompanyCode: "يرجى إدخال رمز الشركة",
    register: "تسجيل",
    setAccountInfo: " ضبط معلومات الحساب",
    sendAuthCode: " رمز البريد الإلكتروني",
    next: "التالي",
    backLogin: "العودة لتسجيل الدخول",
    verificationCodeInfo: "تم إرسال رمز التحقق",
    username: "الإسم المستعار",
    inputPaw: "أدخل رقم التعريف الشخصي لتسجيل الدخول",
    inputPaw2: "يرجى إدخال كلمة المرور مرة أخرى",
    registerSuccess: "تم التسجيل بنجاح",
    correctError: "يرجى إدخال كلمة المرور الصحيحة",
    confirm: "تأكيد",
    logout: "تسجيل الخروج",
    customerNumber: "رقم العميل",
    companyName: "Prolinker Holdings (Guangzhou) Co., Ltd.",
    logoText: "China International Express",
    codeNotice: "هل ما زلت تنتظر رمز التحقق؟ تحقق من الرسائل المزعجة الخاصة بك."
  },
  address: {
    addAddress: "إنشاء عنوان التسليم ",
    editAddress: "تعديل عنوان التسليم",
    addressTitle: "عنوان التسليم الأجنبي",
    postcode: "الرمز البريدي",
    email: "البريد الإلكتروني",
    input: "يرجى الإدخال",
    select: "يرجى الإختيار",
    receivingName: "المستلم",
    phoneNumber: "رقم الاتصال",
    country: "البلد",
    city: "المدينة",
    receivingAddress: "تفاصيل عنوان التسليم",
    isDefault: "عنوان التسليم الافتراضي",
    submit: "إرسال",
    delete: "حذف",
    selectAddress: "الرجاء اختيار العنوان",
    chinese1: "عنوان توصيلك الصيني",
    chinese2: "مستودع",
    chinese3: "الاتصال",
    chinese4: "الهاتف",
    chinese5: "العنوان",
    copy: "انقر للنسخ"
  },
  information: {
    title: "تعديل المعلومات الشخصية",
    input: "يرجى الإدخال",
    select: "يرجى الاختيار",
    companyName: "الاسم الكامل (الرجل/المرأة)",
    companyNameEn: "اسم الشركة باللغة الإنجليزية",
    companyNameSn: "اسم الشركة باختصار",
    companyNameContact: "ممثل الشركة للاتصال",
    legalPerson: "الممثل القانوني",
    telePhone: "رقم الهاتف",
    webSite: "الموقع الإلكتروني",
    address: "العنوان",
    certificate: "رخصة تسجيل الأعمال",
    personalPassport: "رقم جواز السفر",
    personalID: "رقم التعريف",
    customerPhone: "رقم الاتصال",
    email: "البريد الإلكتروني",
    country: "البلد",
    city: "المدينة",
    password: "كلمة السر",
    submit: "إرسال",
    alert: "يرجى التحقق من معلوماتك",
    name: "الاسم",
    customerNumber: "الهوية",
    phoneNumber: "رقم الهاتف",
    availablePoints: "النقاط المتاحة",
    pointsTitle: "نقاطي",
    pointsSubTitle: "سجل النقاط",
    changeType1: "دخل النقاط",
    changeType2: "تُنفق النقاط",
    changeType3: "خصم النقاط",
    changeType4: "تقليل النقاط",
    searchBar: "يرجى إدخال رقم تتبع الشحنة",
    validator: "تم استخدام هذا الاسم. يمكنك الاختيار من بين الأسماء التالية أو تعديله بنفسك"
  },
  freightInquiry: {
    tableTitle: "خدمة عرض الأسعار",
    countryName: "إسم البلد",
    cargoCategory: "فئة الشحن",
    placeHolder: "يرجى اختيار البلد",
    divider: "الوزن الإضافي",
    col1: "فئة السلعة",
    col2: "وحدة الوزن الأساسية",
    col3: "سعر وحدة الوزن الأساسية",
    col4: "الوزن الإضافي",
    col5: "سعر وحدة الوزن الإضافي",
    col6: "زمن النقل",
    day: "أيام",
    warehouseContact: "جهة الاتصال",
    warehousePhone: "رقم الاتصال",
    warehouseAddress: "عنوان المستودع",
    copy: "انقر للنسخ",
    empty: "لا توجد بيانات",
    none: "لا شيء",
    remark: "ملاحظة",
  },
  cargoInquiry: {
    input: "يرجى الإدخال",
    wbNumber: "رقم بوليصة الشحن",
    search: "بحث",
    copy: "نسخ",
    title1: "معلومات الشحن",
    title2: "عنوان التسليم",
    title3: "معلومات سريعة",
    title4: "معلومات الشحنة",
    title5: "التتبع اللوجستي",
    logisticsStatus: "الحالة اللوجستية",
    receivingName: "المستلم",
    phoneNumber: "رقم الاتصال",
    receivingAddress: "عنوان التسليم",
    boxNumber: "رقم الصندوق",
    volume: "الحجم",
    weight: "الوزن",
    pol: "ميناء التحميل",
    pod: "ميناء التفريغ",
    cargoName: "اسم العنصر",
    cargoQuantity: "كمية العنصر",
    goodsValue: "قيمة العنصر",
    currency: "عملة",
    quantityUnit: "وحدة الكمية",
    numberPackages: "عدد الطرود",
    chargeableWeight: "الوزن القابل للشحن",
    copySuccess: "نجاح النسخ",
    wbType1: "الشحن الجوي",
    wbType2: "الشحن البحري",
    wbType3: "من الجو للباب",
    wbType4: "من البحر للباب",
    wbType5: "السريع",
    logisticsState1: "قيد النقل",
    logisticsState2: "انتظار الاستلام",
    logisticsState3: "انتظار التسليم",
    logisticsState4: "التسليم قيد التنفيذ",
    logisticsState5: "تم التوقيع",
    signTime: "وقت التوقيع",
    updateTime: "وقت تحديث الخدمات اللوجستية",
    viewLogistics: "عرض الخدمات اللوجستية",
    allFilter: "جميع الفلاتر",
    dateRange: "نوع نطاق التاريخ",
    dateType1: "اليوم",
    dateType2: "آخر 7 أيام",
    dateType3: "آخر 30 يوماً",
    dateType4: "التاريخ المخصص",
    selectStartDate: "يرجى تحديد تاريخ البدء",
    selectEndDate: "يرجى تحديد تاريخ الانتهاء",
    to: "إلى",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    reset: "إعادة تعيين",
    confirm: "تأكيد",
    tab1: "غير مكتمل",
    tab2: "مكتمل",
    year: "",
    month: "",
    day: "",
    inputText: "إدخال رقم التتبع",
    searchText: "بحث",
    filter: "فلترة",
  },
  orderDetail: {
    expressNumber: "الرقم السريع",
    cargoTrackingNumber: "رقم تتبع الشحنات",
    cargoName: "اسم العنصر",
    cargoQuantity: "كمية العنصر",
    goodsValue: "قيمة العنصر",
    currency: "عملة",
    quantityUnit: "وحدة الكمية",
    isUnpack: "إعادة التعبئة",
    countryName: "إسم البلد",
    cargoCategory: "فئة الشحن",
    numberPackages: "عدد الطرود",
    volume: "الحجم",
    weight: "الوزن",
    chargeableWeight: "الوزن القابل للشحن",
    editOrder: "تعديل الطلب",
    deleteOrder: "حذف الطلب",
    wbNumber: "رقم التتبع",
    billState1: "غير مدفوع",
    billState2: "مدفوعة الأجر",
    billState3: "لا مراجعة",
    boxNumber: "رقم الصندوق",
    inboundBoxNumber: "لا. مربع الوارد",
    viewLogistics: "حالة الشحن",
    viewBillList: "قائمة البيانات",
    payBillList: "ادفع الفاتورة",
    viewShipping: "طريقة التوصيل",
    viewException: "استثناء التسليم",
    exceptionTitle: "مناولة الاستثناءات",
    exceptionReason: "السبب في تسليم الإستثناء",
    confirmReceipt: "استلام التأكيد",
    allFilter: "جميع الفلاتر",
    select: "يرجى اختيار",
    cargoSelect: "الرجاء اختيار اسم البلد أولاً",
    reset: "إعادة تعيين",
    confirm: "تأكيد",
    shippingAlertTitle: "يرجى اختيار طريقة التوصيل",
    shippingType1: "الاستلام من المستودع",
    shippingType2: "تقديم طلب التوصيل",
    selectAddress: "اختر العنوان",
    receivingName: "المستلم",
    phoneNumber: "رقم الاتصال",
    receivingAddress: "عنوان التسليم",
    state1: "القادم",
    state2: "الوارد",
    state3: "قيد النقل",
    state4: "جاهز للاستلام",
    state5: "جاهز للتسليم",
    state6: "مكتمل",
    state7: "تم إلغاء",
    confirmDelete: "هل أنت متأكد من حذف الطلب؟",
    inputText: "يرجى الإدخال",
    search: "بحث",
    filter: "التصفية",
    sideWbNumber: "رقم بوليصة الشحن الداخلية",
    exceptionText(val) {
      return "يتم دعم عملية إعادة الانتداب حتى 3 مرات على الأكثر. يمكنك أيضا تشغيل " + val + " أوقات";
    },
    eState1: "إعادة تعيين",
    eState2: "العودة إلى المخزن",
    exceptionTrim: "ويبلغ الحد الأقصى لعدد الأشخاص الذين يعاد تعيينهم ثلاث مرات",
    payType: "اختر طريقة الدفع",
    onPay: "ادفع الآن",
    paymentOption1: "Alipay",
    paymentOption2: "Wechat",
    viewDetail: "عرض التفاصيل",
    paySuccess: "نجاح عملية الدفع",
    payFailure: "فشل عملية الدفع",
    searchType: "ظروف البحث",
    serviceFee: "رسوم الخدمة",
    availablePoints: "النقاط المتاحة",
    deductibleAmount: "المبلغ القابل للخصم",
    taxFeebearingParty: "المُدَّعِي الضريبي",
    shipper: "المُرسل",
    consignee: "المستلم",
    completeOrderGoodsValue: "من فضلك اكمل المعلومات",
    discount: "خصم طلب للمرة الأولى"
  },
  goodsForecast: {
    input: "يرجى الإدخال",
    select: "يرجى الاختيار",
    nextStep: "الخطوة التالية",
    expressNumber: "الرقم السريع",
    expressNumberPlaceHolder: "يرجى إدخال رقم الشحن الداخلي للطرود الواردة",
    cargoName: "اسم العنصر",
    cargoQuantity: "كمية العنصر",
    goodsValue: "قيمة العنصر",
    currency: "عملة",
    quantityUnit: "وحدة الكمية",
    customUnit: "وحدات مخصصة",
    boxNumber: "رقم الصندوق",
    countryName: "اسم البلد",
    cargoCategory: "فئة الشحن",
    productImage: "صورة المنتج",
    receivingAddress: "عنوان التسليم",
    submit: "إرسال",
    uploaderText1: "انقر لتحميل",
    uploaderText2: "يدعم صيغة JPG وPNG، بحجم أقصى يبلغ 10 ميجابايت.",
    stepperLabel: "إضافة / إزالة",
    other: "آخرون",
    isUnpack: "إعادة التعبئة",
    question: "قم بإزالة وحزم مرة أخرى لتوفير المساحة والتكلفة.",
    createText: "تذكير: إتمام إشعار الوارد. تحقق من بوليصة الشحن وقم بإتمام الدفع.",
    productCategory: "فئة المنتج",
    totalTax: "الضرائب المقدرة",
    taxFeebearingParty: "المُدَّعِي الضريبي",
    shipper: "المُرسل",
    consignee: "المستلم",
    englishOnly: "السماح فقط بالإدخال باللغة الإنجليزية",
    translate: "ترجمة"
  },
  accountList: {
    accountBalance: "رصيد الشحن المقدّم",
    fundType1: "الشحن المسبق",
    fundType2: "مدفوعات الشحن",
    fundType3: "قيد صرف العملات",
    fundType4: "صرف النفقات",
    currency: "العملة",
    balance: "الرصيد",
    allFilter: "جميع الفلاتر",
    fundTypeStr: "نوع التمويل",
    reset: "إعادة تعيين",
    confirm: "تأكيد",
    search: "بحث",
    filter: "تصفية",
    input: "يرجى الإدخال"
  },
  paybillList: {
    totalAmount: "المبلغ الإجمالي",
    approvedAmount: "المبلغ المعتمد",
    billState1: "غير مدفوع",
    billState2: "مدفوعة الأجر",
    billState3: "لا مراجعة",
    subTotalAmount: "المبلغ الإجمالي الفرعي",
    subApprovedAmount: "المبلغ المعتمد من الباطن",
    chargeMoney: "بنود الشحن",
    payableBills: "فاتورة مستحقة الدفع",
    dialogCurrencyTitle: "يرجى اختيار عملة الدفع",
  },
  calculator: {
    title: "يرجى إدخال المعلومات للتحقق من السعر أولاً",
    input: "يرجى الإدخال",
    select: "يرجى الاختيار",
    length: "الطول (سم)",
    width: "العرض (سم)",
    height: "الارتفاع (سم)",
    weight: "الوزن الإجمالي (كجم)",
    search: "بحث",
    col1: "البلد / المنطقة الوجهة",
    col2: "وحدة الوزن الأساسية",
    col3: "سعر وحدة الوزن الأساسية",
    col4: "الوزن الإضافي",
    col5: "سعر وحدة الوزن الإضافي",
    col6: "زمن النقل",
    day: "أيام",
    empty: "لا توجد بيانات",
    remark: "ملاحظة",
    orderBy1: "ارتفاع السعر",
    orderBy2: "السعر الهابط",
    packageSize: "الحجم الإجمالي",
    totalFreight: "تقدير الشحن"
  },
  shopping: {
    isCoupon: "خصم",
    isBrand: "علامة تجارية",
    isAttestation: "الشهادة",
    isNotEmail: "من فضلك اكمل عنوان بريدك الإلكتروني أولاً",
    productInfo: "معلومات المنتج",
    descriptions: "وصف المنتج",
    weight: "الوزن",
    volume: "الحجم",
    quantity: "الكمية",
    inventory: "المخزون",
    none: "لا شيء",
    addShop: "أضف إلى المفضلة",
    shopCarList: "سلة التسوق",
    productList: "قائمة المنتجات",
    msg1: "المنتج لا يحتوي على مجموعة من أسعار المنتجات",
    msg2: "المنتج لا يحتوي على مواصفات",
    msg3: "لا يمكن العثور على سعر المنتج في مجموعة أسعار المنتجات المقابلة",
    msg4: "فئة SKU لا تتطابق مع طول SKU السعر لهذا المنتج. يُرجى التواصل مع المسؤول",
    msg5: "لا توجد فئات فرعية لهذا المنتج. يُرجى التواصل مع المسؤول",
    msg6: "لم يتم العثور على سعر المنتج في فئة الرموز التجارية. يُرجى التواصل مع المسؤول",
    msg7: "لا يمكن العثور على أسعار الوحدات التصنيفية للبضائع في المجموعة",
    msg8: "هذا المنتج غير متوفر",
    refresh: "تحديث"
  }
};
export default messages;
